function initializeByDom (dom) {
  const $el = $(dom);
  const basePath = $el.data('comp-path');
  const BaseComponent = require('app/components/' + basePath + '/view');
  BaseComponent.prototype.$el = $el;
  $el.data.compInstance = new BaseComponent();
}

function initialize ($root) {
  const $comps = $root ? $root.find('.js-comp') : $('.js-comp').not('.eve-component'); // eve-component 采宝
  $comps.each(function () {
    try {
      initializeByDom($(this));
    } catch (e) {
      console.error(e);
    }
  });
}

module.exports = { initialize, initializeByDom };
